import { render, staticRenderFns } from "./ConfirmationComponent.vue?vue&type=template&id=a3258664&scoped=true"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationComponent.vue?vue&type=style&index=0&id=a3258664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3258664",
  null
  
)

export default component.exports